import { createContext, useContext } from "react";
import { ModelStatus } from "@rapid/components/flow/shared/ModelStatus/cms";
import {
    DataMode,
    WorkflowCredentialsType,
    RapidWorkflowDataType
} from "@rapid/components/flow/shared/Deploy/documentation/types";
import type { CreateRapidWorkflowProps } from "@rapid/types/workflow";

export type DeployContextType = {
    dataMode: DataMode;
    setDataMode: React.Dispatch<React.SetStateAction<DataMode>>;
    modelStatus: ModelStatus;
    workflowCredentials: WorkflowCredentialsType;
    hasValidWorkflowCredentials: boolean;
    apiKey: string;
    loading: boolean;
    setLoading: React.Dispatch<React.SetStateAction<boolean>>;
    creatingRapidWorkflow: boolean;
    createRapidWorkflowDeploy: (
        props: Omit<CreateRapidWorkflowProps, "buildMetadata" | "exampleData">
    ) => Promise<RapidWorkflowDataType>;
    getWorkflowEndpoint: (workspaceUrl: string, workflowUrl: string) => string;
};

export const DeployContext = createContext<DeployContextType>({} as DeployContextType);

export type DeployContextProviderValueType = Omit<DeployContextType, "setDataMode">;

export const useDeployContext = () => {
    return useContext(DeployContext);
};
